import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgForm } from '@angular/forms';
import { IDocumentType } from '../../../message-models/document-type.interface';
import { IEntityDocumentSummary } from '../../../message-models/entity-document-summary';
import { IDateTimeWithZone } from '../../../common/date-time-with-zone.interface';
import { FileUpload } from "primeng/fileupload";

@Component({
  selector: 'app-document-uploader',
  templateUrl: './document-uploader.component.html',
  styleUrls: ['./document-uploader.component.scss']
})
export class DocumentUploaderComponent implements OnInit, AfterViewInit {
  acceptedFileTypes = '.doc, .docx,.png, .jpg, .jpeg, .txt,.ppt, .pptx,.xls, .xlsx, .xlsm, .pdf';
  @ViewChild('documentUploadForm', { static: true }) documentUploadForm: NgForm;
  @ViewChild('uploader', { static: true }) uploader: FileUpload;
  @Input() isEditing = true;
  @Input() isViewOnly = false;
  @Input() saveAttempted: boolean = true;
  @Input() submitted: boolean = false;
  @Input() maxFileSize = 20971520; // TODO Get max file size from settings.. default to 20mb
  defaultFileName;
  // @Output() documentUploadFormChange: EventEmitter<any> = new EventEmitter<any>();
  @Input() documentTypes: IDocumentType[];
  @Input() documentSummary: IEntityDocumentSummary;
  @Output() formStatusChange: EventEmitter<any> = new EventEmitter<File>();
  @Output() canSave: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() fileUpload: EventEmitter<File> = new EventEmitter<File>();
  @Output() fileRemove: EventEmitter<boolean> = new EventEmitter<boolean>();

  file: File;
  //errorMessage: string;
  //showErrorMessage = false;
  @Output() documentUploadRequest: EventEmitter<any> = new EventEmitter<any>();
  otherDocumentType: any;
  selectedDocumentTypeId: any;
  addingNewDocumentType: boolean;
  newDocumentType: any;
  saveNewDocumentTypeAttempted: any;
  tempFileName: string = '';
  creationMaxDate: Date = new Date(Date.now());
  selectedMaxDate: Date = new Date(Date.now());
  selectedMinDate: Date;
  filetypeTooltip: string;


  constructor() {
  }

  ngOnInit(): void {
    if (this.documentSummary?.originalFilename !== '') {
      this.defaultFileName = this.documentSummary.originalFilename;
    }
    if (this.documentSummary?.documentCreationDate !== null || true) {
      this.disableDatesPriorSelected(this.documentSummary.documentCreationDate);
    }
    if ((this.documentSummary?.documentCreationDate !== null || true) && (this.documentSummary?.expiryDate !== null || true)) {
      this.setReviewDateLimit();
    }

    if (this.documentSummary.documentTypeId === '') {
      const defaultDocumentType = this.documentTypes.find(c => c.isDefault);
      if (defaultDocumentType) {
        this.documentSummary.documentTypeId = defaultDocumentType.id;
      }
    }
    this.initTooltip();
  }

  ngAfterViewInit() {
    this.documentUploadForm.form.statusChanges.subscribe(() => {
      this.documentUploadRequest.emit(this.documentSummary);
      if (!this.documentSummary.documentCreationDate.dateTime !== undefined || true) {
        this.canSave.emit(this.documentUploadForm.form.valid);
      }
    });
  }

  initTooltip() {
    this.filetypeTooltip =
      'We accept the following files, under 5MB size:'
      + '<ul class="list-group">'
      + '<li class="list-group-item"><div class="row">'
      + '<div class="col" style="text-align:left"><span class="far fa-file-pdf"></span>&nbspAcrobat</div>'
      + '<div class="col" style="text-align:right">.pdf</div>'
      + '</div></li>'
      + '<li class="list-group-item"><div class="row">'
      + '<div class="col" style="text-align:left"><span class="far fa-file-excel"></span>&nbspExcel</div>'
      + '<div class="col" style="text-align:right">.xls, .xlsx, .xlsm</div>'
      + '</div></li>'
      + '<li class="list-group-item"><div class="row">'
      + '<div class="col" style="text-align:left"><span class="far fa-file-powerpoint"></span>&nbspPowerPoint</div>'
      + '<div class="col" style="text-align:right">.ppt, .pptx</div>'
      + '</div></li>'
      + '<li class="list-group-item"><div class="row">'
      + '<div class="col" style="text-align:left"><span class="far fa-file-alt"></span>&nbspPlain Text</div>'
      + '<div class="col" style="text-align:right">.txt</div>'
      + '</div></li>'
      + '<li class="list-group-item"><div class="row">'
      + '<div class="col" style="text-align:left"><span class="far fa-file-word"></span>&nbspWord</div>'
      + '<div class="col" style="text-align:right">.doc, .docx</div>'
      + '</div></li>'
      + '<li class="list-group-item"><div class="row">'
      + '<div class="col" style="text-align:left"><span class="far fa-image-polaroid"></span>&nbspImages</div>'
      + '<div class="col" style="text-align:right">.png, .jpg, .jpeg</div>'
      + '</div></li>'
      + '</ul>'
      + '<label>Please note that we cannot accept files exceeding 5MB in size.</label>'
  }

  disableDatesPriorSelected(date: IDateTimeWithZone) {
    if (date.dateTime) {
      let observedOn = new Date(date.dateTime);
      this.selectedMinDate = new Date(observedOn.setDate(observedOn.getDate() + 1));
    }
  }

  onFileRemove(file?: File) {
    const index = this.uploader.files.indexOf(file);
    if (index > -1) {
      this.uploader.remove(null, index);
    }
    this.defaultFileName = this.tempFileName;
    this.documentSummary.originalFilename = this.tempFileName;
    this.fileRemove.emit(true);
    // this.formStatusChange.emit(false);
  }

  onFileAdd(event: any) {
    if (event?.files?.length > 0) {
      const file = event?.files[0];
      //this.showErrorMessage = false;
      if (file.size > this.maxFileSize) {
        //this.showErrorMessage = true;
        //this.errorMessage = `${file.name} exceeds the maximum upload size permitted`;
        this.uploader.clear();
      } else {
        this.tempFileName = this.documentSummary.originalFilename;
        this.documentSummary.originalFilename = file.name;
      }
      this.defaultFileName = file.name;
      this.fileUpload.emit(file);
      this.formStatusChange.emit(this.documentUploadForm.form.valid);
    }

  }

  removeDefaultFile() {
    this.defaultFileName = '';
  }

  getSelectedDocumentType(documentTypeId: string): IDocumentType {
    return this.documentTypes?.find(t => t.id === documentTypeId);
  }

  setReviewDateLimit() {
    if (this.documentSummary?.documentCreationDate.dateTime && this.documentSummary?.expiryDate.dateTime) {
      let expiresOn = new Date(this.documentSummary?.expiryDate?.dateTime);
      let currentDate = new Date(Date.now());
      let newExpiryDate = new Date(expiresOn.setDate(expiresOn.getDate() - 1));
      this.selectedMaxDate = newExpiryDate;
      this.creationMaxDate = currentDate < newExpiryDate ? currentDate : newExpiryDate;
    }
  }
}
